import { ArrowUpRight } from 'lucide-react';
import { type Credential, qualifier } from '@/content/credentials';

/**
 * One credential, rendered with exactly what is known about it: the official
 * artwork when the owner has supplied it, a tier/date qualifier when set, a
 * source link when there is one. Nothing is ever printed for a missing field.
 *
 * A full lockup (`badge.says`) stands alone with the sentence as its alt; a
 * symbol sits beside the sentence. `artwork={false}` gives the sentence only,
 * for places where the logo is already shown nearby.
 */
export function CredentialLine({
  c,
  form,
  artwork = true,
}: {
  c: Credential;
  form: 'short' | 'long';
  artwork?: boolean;
}) {
  const text = form === 'short' ? c.short : c.long;
  const badge = artwork ? c.badge : null;
  const source = c.sourceUrl && (
    <a
      href={c.sourceUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="ml-1 inline-flex items-center text-primary hover:underline"
      aria-label={`Source: ${c.long}`}
    >
      <ArrowUpRight className="h-3.5 w-3.5" />
    </a>
  );

  if (badge?.says) {
    return (
      <>
        <img src={badge.src} width={badge.width} height={badge.height} alt={text} className={`${badge.className} w-auto shrink-0`} />
        {source}
      </>
    );
  }
  return (
    <>
      {badge && (
        <img src={badge.src} width={badge.width} height={badge.height} alt="" className={`${badge.className} w-auto shrink-0`} />
      )}
      <span>
        {text}
        {form === 'long' && qualifier(c)}
        {source}
      </span>
    </>
  );
}
